import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';

export function AppLayout() {
	const [isMenuOpen, setMenuOpen] = useState(false);
	const location = useLocation();

	// Đổi route thì đóng drawer và cuộn lên đầu trang.
	useEffect(() => {
		setMenuOpen(false);
		window.scrollTo({ top: 0, behavior: 'instant' });
	}, [location.pathname, location.search]);

	// Khoá scroll nền khi drawer mở trên mobile.
	useEffect(() => {
		document.body.style.overflow = isMenuOpen ? 'hidden' : '';
		return () => {
			document.body.style.overflow = '';
		};
	}, [isMenuOpen]);

	return (
		<div className="flex min-h-screen">
			<Sidebar isOpen={isMenuOpen} onNavigate={() => setMenuOpen(false)} />

			{isMenuOpen && (
				<button
					type="button"
					aria-label="Đóng menu"
					onClick={() => setMenuOpen(false)}
					className="fixed inset-0 z-35 bg-black/60 backdrop-blur-sm min-[700px]:hidden"
				/>
			)}

			<main className="min-w-0 flex-1 px-[4.2%] pb-11">
				<Topbar
					onToggleMenu={() => setMenuOpen((open) => !open)}
					isMenuOpen={isMenuOpen}
				/>
				<Outlet />
				<footer className="mt-14 border-t border-line pt-5.5 text-center text-xs text-muted">
					© {new Date().getFullYear()} NekoStream · Dữ liệu phim từ{' '}
					<a
						href="https://phimapi.com"
						target="_blank"
						rel="noreferrer noopener"
						className="text-accent hover:underline"
					>
						phimapi.com
					</a>{' '}
					· Chúc bạn xem phim vui vẻ ♡
				</footer>
			</main>
		</div>
	);
}
